import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useNavigationGuardStore, useResetNavigationGuard } from '@features/navigationGuard/store';

export function useNavigationGuard() {
  const navigate = useNavigate();
  const shouldBlock = useNavigationGuardStore();
  const resetGuard = useResetNavigationGuard();

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (shouldBlock) {
        e.preventDefault();
        e.returnValue = ''; // Triggers built in navigation confirmation dialog
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [shouldBlock]);

  const guardedNavigate = useCallback(
    (to: string) => {
      if (shouldBlock && !window.confirm('Leave page?')) return;
      resetGuard();
      navigate(to);
    },
    [shouldBlock, navigate, resetGuard],
  );

  return guardedNavigate;
}
